import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  LECTURE_STUDIO_COURSE_PAGES,
  LECTURE_STUDIO_COURSES,
} from "@/data/lectureStudio";

/** Old /course/<id> links (shared with students) now land on Lecture Studio. */
const LectureStudioRedirect: React.FC = () => {
  const courseId = useParams()["*"]?.split("/")[0] ?? "";
  const target =
    LECTURE_STUDIO_COURSE_PAGES[courseId] ?? LECTURE_STUDIO_COURSES;

  useEffect(() => {
    window.location.replace(target);
  }, [target]);

  return (
    <p className="font-mono text-sm">
      Courses have moved to{" "}
      <a href={target} className="link-minimal">
        Lecture Studio
      </a>
      .
    </p>
  );
};

export default LectureStudioRedirect;
